import { render, staticRenderFns } from "./ServicesDetailed.vue?vue&type=template&id=2a88ee19&scoped=true&"
import script from "./ServicesDetailed.vue?vue&type=script&lang=js&"
export * from "./ServicesDetailed.vue?vue&type=script&lang=js&"
import style0 from "./ServicesDetailed.vue?vue&type=style&index=0&id=2a88ee19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a88ee19",
  null
  
)

export default component.exports